import getActionsByDocument from '../../../../../components/comments/actions';

const DOCUMENT = 'SUB_UNIT_COMMENTS_';

export default getActionsByDocument(DOCUMENT);
